import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromFolders from './+state/folders.reducer';
import { FoldersEffects } from './+state/folders.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromFolders.FOLDERS_FEATURE_KEY,
      fromFolders.foldersReducer
    ),
    EffectsModule.forFeature([FoldersEffects]),
  ],
})
export class SharedDataAccessFoldersModule {}
